<mat-card class="eiq-state-card" [attr.role]="'region'">
  <mat-card-content>
    <span class="eiq-state-card__title fs__sm fw__500 caption">{{ name }}</span>

    <div class="eiq-state-card__subtitle">
      <div class="eiq-state-card__subtitle__data">
        <span class="eiq-state-card__subtitle__data-value fs__xl fw__600" [ngClass]="'eiq-' + primaryColor">{{ value }}</span>
      </div>

      <ng-content select="[slot=secondary]"></ng-content>
    </div>
  </mat-card-content>
</mat-card>
